import PersonWithHeart from "./person-with-heart.svg";

export default PersonWithHeart;
